export default __webpack_public_path__ + "static/rpa-shipping-automation-f375d8b811907642df878b1be3968fed.png";